import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MapIcon from '@mui/icons-material/Map';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

function Main() {
  const navigate = useNavigate();

  const handleToursClick = () => {
    navigate('/ManageTours');
  };

  const handleCarRentsClick = () => {
    navigate('/ManageCars');
  };

  useEffect(() => {
    const hasRefreshed = sessionStorage.getItem('hasRefreshed');
    console.log("hasRefreshed:", hasRefreshed);
    if (!hasRefreshed) {
      sessionStorage.setItem('hasRefreshed', 'true');
      window.location.reload();
    }
  }, []);

  return (
    <div className="page-shell hero-page">
      <section className="hero-banner">
        <div>
          <span className="eyebrow">Travel operations</span>
          <h1>Plan trips, routes, and rides with clarity.</h1>
          <p>
            Manage tour packages and rental cars from a cleaner workspace built for fast updates,
            easy scanning, and a modern travel brand feel.
          </p>
        </div>
      </section>

      <section className="dashboard-grid" aria-label="Admin shortcuts">
        <button type="button" className="travel-card card-tours" onClick={handleToursClick}>
          <span className="icon-pill">
            <MapIcon />
          </span>
          <h2>Tours</h2>
          <p>Create routes, update day plans, review images, and keep package details fresh.</p>
        </button>

        <button type="button" className="travel-card card-cars" onClick={handleCarRentsClick}>
          <span className="icon-pill">
            <DirectionsCarIcon />
          </span>
          <h2>Car Rents</h2>
          <p>Maintain rental vehicle categories, passenger counts, pricing, and gallery images.</p>
        </button>
      </section>
    </div>
  );
}

export default Main;
